import { pickT } from "@repo/shared";
import type { QuizSettings } from "@repo/shared/types";
import { validateQuizConfig } from "@repo/shared/types";
import { T } from "./quiz-settings-error.i18n";

/**
 * Human-readable reason the quiz cannot be saved yet, or null when it is fine.
 * Runs the same `validateQuizConfig` the server runs, so the dialog can never
 * offer a shape the API will reject.
 */
export function quizSettingsError(value: QuizSettings, language: string): string | null {
  const key = validateQuizConfig(value);
  if (!key) return null;
  const t = pickT(T, language) as Record<string, string>;
  return t[key] ?? key;
}
